import StyledToggleButtonGroup from "@/components/PageEditor/components/Viewport/components/Toolbar/components/StyledToggleButtonGroup/StyledToggleButtonGroup";
import { SelectionUtils } from "@/utils/SelectionUtils";
import FormatColorResetIcon from "@mui/icons-material/FormatColorReset";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import ToggleButton from "@mui/material/ToggleButton";
import { useEffect, useRef, useState } from "react";

const Toolbar = () => {
    const [enabled, setEnabled] = useState<boolean>(false);

    const [format, setFormat] = useState<string | null>(null);

    const selectionUtils = useRef<SelectionUtils>(new SelectionUtils());

    useEffect(() => {
        document.addEventListener("selectionchange", onSelectionChange, true);

        return () => {
            document.removeEventListener("selectionchange", onSelectionChange, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSelectionChange = () => {
        const activeSelection = SelectionUtils.get();
        if (!activeSelection) return;

        const baseNode = activeSelection.anchorNode as HTMLElement;
        if (!baseNode) return;

        const baseNodeParent = baseNode.parentElement as HTMLElement;
        if (
            (baseNode.closest && baseNode.closest(".craftjs-toolbar")) ||
            (baseNodeParent.closest && baseNodeParent.closest(".craftjs-toolbar")) ||
            (baseNode.closest && baseNode.closest(".color-picker-overlay")) ||
            (baseNodeParent.closest && baseNodeParent.closest(".color-picker-overlay")) ||
            (baseNode.closest && baseNode.closest(".link-popper")) ||
            (baseNodeParent.closest && baseNodeParent.closest(".link-popper"))
        ) {
            setEnabled(false);
            return;
        }

        setEnabled(true);

        if ((activeSelection.type === "Range" || activeSelection.type === "Caret") && activeSelection.rangeCount > 0) {
            selectionUtils.current.save();
        } else if (activeSelection.type) {
            selectionUtils.current.clearSaved();
        }

        updateState();
    };

    const updateState = () => {
        updateFormatting();
    };

    const updateFormatting = () => {
        setFormat(null);
    };

    const onToggleCommand = (cmd: string, showUi: boolean = false, value: string | undefined = undefined) => {
        selectionUtils.current.restore();
        document.execCommand(cmd, showUi, value);
        updateState();
    };

    const onHighlight = () => {
        const activeSelection = SelectionUtils.get();
        if (!activeSelection) return;

        const node = document.createElement("span");
        node.appendChild(activeSelection.getRangeAt(0).cloneContents());

        if (node.innerHTML === "") return;
        const html = `<span class="text-primary-500">${node.innerText}</span>`;

        onToggleCommand("insertHTML", false, html);
    };

    const onRemoveHighlight = () => {
        let activeSelection = SelectionUtils.get();
        if (!activeSelection) return;

        const node = document.createElement("span");
        node.appendChild(activeSelection.getRangeAt(0).cloneContents());

        document.execCommand("removeFormat");

        activeSelection = SelectionUtils.get();
        if (!activeSelection) return;

        const parent = activeSelection.getRangeAt(0).commonAncestorContainer.parentElement as HTMLElement;
        setTimeout(() => {
            parent.classList.remove("text-primary-500");

            if (parent.classList.length === 0) {
                parent.removeAttribute("class");
                parent.replaceWith(parent.innerText);
            }
        }, 100);
    };

    return (
        <>
            <StyledToggleButtonGroup
                disabled={!enabled}
                size="small"
                value={format}
                exclusive
                aria-label="slogan formatting"
            >
                <ToggleButton
                    value="highlight"
                    aria-label="highlight"
                    disabled={format !== null}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        onHighlight();
                    }}
                >
                    <FormatColorTextIcon />
                </ToggleButton>
                <ToggleButton
                    value="clear"
                    aria-label="clear"
                    onMouseDown={(e) => {
                        e.preventDefault();
                        onRemoveHighlight();
                    }}
                >
                    <FormatColorResetIcon />
                </ToggleButton>
            </StyledToggleButtonGroup>
        </>
    );
};

export default Toolbar;
